import {
	AFTER_SALES_ORDERS_LIST_FILTERED,
	AFTER_SALES_ORDERS_LIST_FILTERED_SUCCESS,
	AFTER_SALES_ORDERS_LIST_FILTERED_ERROR,
	AFTER_SALES_ORDER_IMPORT_OR_UPDATE,
	AFTER_SALES_ORDER_IMPORT_OR_UPDATE_SUCCESS,
	AFTER_SALES_ORDER_IMPORT_OR_UPDATE_ERROR,
} from "../actions/afterSalesOrders";
import AfterSalesOrdersService from '@/services/afterSalesOrders';

const state = {
	status: '',
};

const getters = {
};

const actions = {
	[AFTER_SALES_ORDER_IMPORT_OR_UPDATE]: ({ commit, dispatch }, orderNumber) => {
		return new Promise((resolve, reject) => {
			commit(AFTER_SALES_ORDER_IMPORT_OR_UPDATE);
			AfterSalesOrdersService.importOrUpdate(orderNumber)
				.then(data => {
					commit(AFTER_SALES_ORDER_IMPORT_OR_UPDATE_SUCCESS);
					resolve(data);
				})
				.catch(error => {
					commit(AFTER_SALES_ORDER_IMPORT_OR_UPDATE_ERROR, error);
					reject(error);
				});
		});
	},
	[AFTER_SALES_ORDERS_LIST_FILTERED]: ({ commit }, data) => {
		let requestData = {
			size: data.tableProps.itemsPerPage,
			page: data.tableProps.currentPage,
			sort: data.ctx.sortBy,
			desc: data.ctx.sortDesc,
		}
		if (data.tableProps.inputFilter.orderNumber) {
			requestData.orderNumberFilter = data.tableProps.inputFilter.orderNumber;
		}
		return new Promise((resolve, reject) => {
			commit(AFTER_SALES_ORDERS_LIST_FILTERED);
			AfterSalesOrdersService.listFiltered(requestData)
				.then(responseData => {
					commit(AFTER_SALES_ORDERS_LIST_FILTERED_SUCCESS, responseData);
					resolve(responseData);
				})
				.catch(error => {
					commit(AFTER_SALES_ORDERS_LIST_FILTERED_ERROR, error);
					reject(error);
				});
		});
	},
};

const mutations = {
	[AFTER_SALES_ORDERS_LIST_FILTERED]: state => {
		state.status = 'loading';
	},
	[AFTER_SALES_ORDERS_LIST_FILTERED_SUCCESS]: (state, responseData) => {
		state.status = 'success';
	},
	[AFTER_SALES_ORDERS_LIST_FILTERED_ERROR]: state => {
		state.status = 'error';
	},
	[AFTER_SALES_ORDER_IMPORT_OR_UPDATE]: state => {
		state.status = 'loading';
	},
	[AFTER_SALES_ORDER_IMPORT_OR_UPDATE_SUCCESS]: (state, responseData) => {
		state.status = 'success';
	},
	[AFTER_SALES_ORDER_IMPORT_OR_UPDATE_ERROR]: state => {
		state.status = 'error';
	},
};

export default {
	state,
	getters,
	actions,
	mutations
};